import { map, filter, head, find } from 'lodash';

const methods = ['internet', 'atm', 'pos', 'manual'];

class TransactionMethod {
  constructor(methodType) {
    this.id = methodType;
    this.title = setTitle(methodType);
    this.isEnable = false;
    this.text = setText(methodType);
    this.iconType = setIcon(methodType);
  }
  setEnabled(isEnable) {
    this.isEnable = isEnable;
  }
  getTitle() {
    return this.title;
  }
  getIconType() {
    return this.iconType;
  }
  getText() {
    return this.text;
  }
  isEnabled() {
    return this.isEnable;
  }
}

const setTitle = (methodType) => {
  switch (methodType) {
    case 'atm':
      return 'At a cash machine';
    case 'internet':
      return 'Online';
    case 'pos':
      return 'Using a card reader';
    case 'manual':
      return 'Where my card details are input by retailer';
    default:
      return undefined;
  }
};

const setIcon = (methodType) => {
  switch (methodType) {
    case 'atm':
      return 'LocationOutlineLarge';
    case 'internet':
      return 'OnlineOutlineLarge';
    case 'pos':
      return 'CreditCardOutlineLarge';
    case 'manual':
      return 'TelephoneOutlineLarge';
    default:
      return undefined;
  }
};

const setText = (methodType) => {
  switch (methodType) {
    case 'pos':
      return 'Contactless, Chip and PIN, Swipe';
    case 'manual':
      return 'Phone, mail, subscriptions, renewals';
    default:
      return undefined;
  }
};

export const getTransactionMethods = (bulkTransactionAlerts) => {
  const transactionMethods = map(methods, (method) => new TransactionMethod(method));
  const filterByMethods = filter(bulkTransactionAlerts.debit_alert, (m) =>
    methods.includes(Object.keys(m)[0])
  );
  filterByMethods.forEach((method) => {
    const methodKey = head(Object.keys(method));
    find(transactionMethods, (m) => m.id === methodKey).setEnabled(method[methodKey].enabled);
  });
  return transactionMethods;
};

export const isTransactionMethodEnabled = (transactionMethods) =>
  transactionMethods.some((method) => method.isEnabled());
